var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-layout',{attrs:{"add-class":_vm.addClass}},[_c('popup-cancel-order',{attrs:{"order-info":_vm.orderInfo},on:{"dispose":_vm.onDispose,"confirm":_vm.onConfirm,"cancel":_vm.onCancel}}),_vm._v(" "),_c('modal-alert',{ref:"refModalAlert"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a0d1621e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal-popups/ModalCancelOrder.vue
// module id = null
// module chunks = 